import { css } from 'emotion';

import { colors, fonts } from '../styles';

export const wrapper = css`
  position: relative;
  z-index: 0;

  display: flex;
  justify-content: space-evenly;

  width: 100%;
  height: 28px;

  padding: 0;

  background: rgba(23, 158, 238, 0.08);
`;

export const step = css`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const label = css`
  font-size: ${fonts.size.small};
  color: ${colors.gray.default};
  white-space: nowrap;
  margin-top: 5px;
  display: felx;
  align-items: space-between;
`;

export const separator = css`
  margin-left: 22px;
  color: ${colors.gray.dark};
`;

export const current = css`
  .${label} {
    color: ${colors.primary.default};
    font-weight: ${fonts.weight.medium};
  }
`;

export const completed = css`
  .${label} {
    color: ${colors.gray.dark};
  }
`;

export const finished = css`
  &:last-child .${label} {
    font-weight: 500;
  }
`;
